import { IDENTITY_SERVER_BASE_PATH_PROVIDER } from './api-base-path.provider';

export const environment = {
  production: true,
  providers: [IDENTITY_SERVER_BASE_PATH_PROVIDER],
  ngxsPluginImports: [],
};
